import React from 'react';

interface InstallScreenProps {
  onContinueToApp: () => void;
}

export const InstallScreen: React.FC<InstallScreenProps> = ({ onContinueToApp }) => {
  const isStandalone = typeof window !== 'undefined' && 
    (('standalone' in window.navigator && (window.navigator as any).standalone) ||
     window.matchMedia('(display-mode: standalone)').matches);

  const isIos = typeof window !== 'undefined' && /iPhone|iPad|iPod/.test(navigator.userAgent);

  return (
    <div className="pwa-tab-scroll" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100%', padding: '32px 24px', textAlign: 'center' }}>
      <div style={{ width: '80px', height: '80px', borderRadius: '40px', background: 'linear-gradient(135deg, #8B5CF6, #6d28d9)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '36px', marginBottom: '24px', boxShadow: '0 8px 24px rgba(139, 92, 246, 0.4)' }}>
        📱
      </div>

      <h1 style={{ fontSize: '24px', fontWeight: '900', color: '#fff', marginBottom: '8px' }}>
        {isStandalone ? 'Console App Installed' : 'Install on iPhone'}
      </h1>

      <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', lineHeight: '1.5', maxWidth: '320px', marginBottom: '32px' }}>
        {isStandalone
          ? 'You are running in standalone web app mode. Experience full-screen native performance!'
          : 'Add this application to your iPhone Home Screen for a seamless native app experience without the App Store.'}
      </p>

      {!isStandalone && isIos && (
        <div style={{ width: '100%', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '20px', padding: '20px', textAlign: 'left', marginBottom: '32px' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
            <div style={{ width: '28px', height: '28px', borderRadius: '14px', background: '#8B5CF6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', fontSize: '13px', color: '#fff', marginRight: '12px' }}>1</div>
            <div style={{ fontSize: '14px', color: '#fff', fontWeight: '600' }}>
              Tap the <span style={{ color: '#a78bfa', fontWeight: '800' }}>Share button</span> in Safari toolbar at the bottom.
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
            <div style={{ width: '28px', height: '28px', borderRadius: '14px', background: '#8B5CF6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', fontSize: '13px', color: '#fff', marginRight: '12px' }}>2</div>
            <div style={{ fontSize: '14px', color: '#fff', fontWeight: '600' }}>
              Scroll down and tap <span style={{ color: '#a78bfa', fontWeight: '800' }}>"Add to Home Screen"</span>.
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: '28px', height: '28px', borderRadius: '14px', background: '#8B5CF6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', fontSize: '13px', color: '#fff', marginRight: '12px' }}>3</div>
            <div style={{ fontSize: '14px', color: '#fff', fontWeight: '600' }}>
              Open <span style={{ color: '#a78bfa', fontWeight: '800' }}>Game Console</span> from your Home Screen!
            </div>
          </div>
        </div>
      )}

      <button onClick={onContinueToApp} className="pwa-primary-btn" style={{ marginTop: '0' }}>
        {isStandalone ? 'ENTER APPLICATION' : 'CONTINUE IN BROWSER'}
      </button>
    </div>
  );
};
